import React, { useState } from 'react';
import { FaArrowDown, FaArrowUp, FaSearch, FaEye, FaTimes } from 'react-icons/fa';
import { useModal } from '../components/Modal';
import '../styles/Transactions.css';

const allTransactions = [
  { id: 'TXN-001', type: 'OUT', aircraft: 'PZ-TAB', pilot: 'Carlos Hew',  vendor: null,     tanker: 'Tanker A', fuelType: 'JET A-1',     amount: 120, unit: 'Gal', date: '2026-02-20', time: '08:14', steps: 9, status: 'completed' },
  { id: 'TXN-002', type: 'IN',  aircraft: null,     pilot: null,           vendor: 'Vendor 1', tanker: 'Tanker B', fuelType: 'JET A-1',   amount: 800, unit: 'Gal', date: '2026-02-20', time: '07:45', steps: 4, status: 'completed' },
  { id: 'TXN-003', type: 'OUT', aircraft: 'PZ-SUR', pilot: 'Mark Lie',    vendor: null,     tanker: 'Tanker A', fuelType: 'JET A-1',     amount: 95,  unit: 'Gal', date: '2026-02-20', time: '07:10', steps: 9, status: 'completed' },
  { id: 'TXN-004', type: 'OUT', aircraft: 'PZ-DBN', pilot: 'Sam Jones',   vendor: null,     tanker: 'Tanker C', fuelType: 'AVGAS 100LL', amount: 210, unit: 'Gal', date: '2026-02-20', time: '06:55', steps: 9, status: 'completed' },
  { id: 'TXN-005', type: 'IN',  aircraft: null,     pilot: null,           vendor: 'Vendor 2', tanker: 'Tanker C', fuelType: 'AVGAS 100LL', amount: 500, unit: 'Gal', date: '2026-02-19', time: '18:30', steps: 4, status: 'completed' },
  { id: 'TXN-006', type: 'OUT', aircraft: 'PZ-KAS', pilot: 'Roy Brunings', vendor: null,    tanker: 'Tanker A', fuelType: 'JET A-1',     amount: 180, unit: 'Gal', date: '2026-02-19', time: '14:22', steps: 9, status: 'completed' },
  { id: 'TXN-007', type: 'OUT', aircraft: 'PZ-NLV', pilot: 'Lisa Pinas',  vendor: null,     tanker: 'Tanker B', fuelType: 'JET A-1',     amount: 63,  unit: 'Gal', date: '2026-02-19', time: '11:05', steps: 9, status: 'completed' },
  { id: 'TXN-008', type: 'IN',  aircraft: null,     pilot: null,           vendor: 'Vendor 1', tanker: 'Tanker A', fuelType: 'JET A-1',  amount: 600, unit: 'Gal', date: '2026-02-18', time: '09:00', steps: 4, status: 'completed' },
];

const stepLabels = {
  OUT: ['Preparation checklist','After-testing checklist','Aircraft QR scan','Pump QR scan','Before capacity','Before meter photo','After capacity','After meter photo','Disconnect checklist'],
  IN:  ['Tank QR scan','Vendor selection','Amount input','Receipt photo'],
};

function TransactionDetail({ tx, closeModal }) {
  const labels = stepLabels[tx.type];
  return (
    <div className="txn-detail">
      <div className="txn-detail-meta">
        <div><span className="meta-label">ID</span> <span>{tx.id}</span></div>
        <div><span className="meta-label">Date</span> <span>{tx.date} {tx.time}</span></div>
        <div><span className="meta-label">Tanker</span> <span>{tx.tanker}</span></div>
        <div><span className="meta-label">Fuel type</span> <span>{tx.fuelType}</span></div>
        <div><span className="meta-label">Amount</span> <span>{tx.amount} {tx.unit}</span></div>
        {tx.aircraft && <div><span className="meta-label">Aircraft</span> <span>{tx.aircraft}</span></div>}
        {tx.pilot    && <div><span className="meta-label">Fueler</span>  <span>{tx.pilot}</span></div>}
        {tx.vendor   && <div><span className="meta-label">Vendor</span>  <span>{tx.vendor}</span></div>}
      </div>
      <div className="txn-steps">
        <h4>Steps completed</h4>
        {labels.map((l, i) => (
          <div key={i} className="txn-step-row">
            <div className="step-num">{i + 1}</div>
            <span>{l}</span>
            <span className="step-done">✓</span>
          </div>
        ))}
      </div>
      <div className="modal-actions">
        <button className="btn btn-secondary" onClick={closeModal}><FaTimes /> Close</button>
      </div>
    </div>
  );
}

export default function Transactions() {
  const [search, setSearch] = useState('');
  const [typeFilter, setTypeFilter] = useState('ALL');
  const { openModal } = useModal();

  const filtered = allTransactions.filter(tx => {
    const matchSearch = (tx.aircraft || tx.vendor || tx.pilot || '').toLowerCase().includes(search.toLowerCase())
      || tx.id.toLowerCase().includes(search.toLowerCase());
    const matchType = typeFilter === 'ALL' || tx.type === typeFilter;
    return matchSearch && matchType;
  });

  const openDetail = (tx) => openModal(`Transaction ${tx.id}`, <TransactionDetail tx={tx} />, 'md');

  const totalOUT = allTransactions.filter(t => t.type === 'OUT').reduce((s, t) => s + t.amount, 0);
  const totalIN  = allTransactions.filter(t => t.type === 'IN').reduce((s, t) => s + t.amount, 0);

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Transactions</h1>
          <p className="page-subtitle">Full history of FuelIN and FuelOUT operations</p>
        </div>
      </div>

      <div className="txn-summary-row">
        <div className="txn-summary-card out">
          <FaArrowUp /> <span>Total dispensed: <strong>{totalOUT} Gal</strong></span>
        </div>
        <div className="txn-summary-card in">
          <FaArrowDown /> <span>Total received: <strong>{totalIN} Gal</strong></span>
        </div>
      </div>

      <div className="filters-row">
        <div className="search-bar">
          <FaSearch className="search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search by aircraft, vendor, fueler, ID..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>
        <div className="filter-btns">
          {['ALL','OUT','IN'].map(f => (
            <button key={f} className={`btn btn-sm ${typeFilter === f ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setTypeFilter(f)}>
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="users-table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Type</th>
              <th>Aircraft / Vendor</th>
              <th>Fueler</th>
              <th>Tanker</th>
              <th>Fuel type</th>
              <th>Amount</th>
              <th>Date / Time</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(tx => (
              <tr key={tx.id}>
                <td className="txn-id">{tx.id}</td>
                <td>
                  <span className={`txn-type-badge ${tx.type === 'OUT' ? 'out' : 'in'}`}>
                    {tx.type === 'OUT' ? <FaArrowUp /> : <FaArrowDown />} {tx.type}
                  </span>
                </td>
                <td>{tx.aircraft || tx.vendor}</td>
                <td>{tx.pilot || '—'}</td>
                <td>{tx.tanker}</td>
                <td>{tx.fuelType}</td>
                <td><strong>{tx.amount} {tx.unit}</strong></td>
                <td>{tx.date} {tx.time}</td>
                <td>
                  <button className="btn btn-sm btn-secondary" onClick={() => openDetail(tx)}>
                    <FaEye />
                  </button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr><td colSpan={9} className="table-empty">No transactions found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
